import { PARTNER_REF_COOKIE, PARTNER_REF_COOKIE_MAX_AGE_DAYS } from '../../domain/partners/types';
import { normalizePartnerCode } from '../../domain/partners/commission';

const MAX_AGE_SECONDS = PARTNER_REF_COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;

export function resolvePartnerRef(search: string): string | null {
  const raw = new URLSearchParams(search).get('ref');
  return normalizePartnerCode(raw);
}

export function readPersistedPartnerRef(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${PARTNER_REF_COOKIE}=`));
  if (!match) return null;
  const value = decodeURIComponent(match.split('=').slice(1).join('='));
  return normalizePartnerCode(value);
}

export function persistPartnerRef(code: string): void {
  const normalized = normalizePartnerCode(code);
  if (!normalized || typeof document === 'undefined') return;
  document.cookie = `${PARTNER_REF_COOKIE}=${encodeURIComponent(normalized)}; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax`;
}

export function resolvePartnerRefForSignup(search: string): string | null {
  return resolvePartnerRef(search) ?? readPersistedPartnerRef();
}

export function capturePartnerRefFromUrl(search = window.location.search): void {
  const fromUrl = resolvePartnerRef(search);
  if (fromUrl) persistPartnerRef(fromUrl);
}

/** Captura ?ref= em qualquer entrada/navegação SPA (boot + popstate). */
export function installPartnerRefCapture(): () => void {
  if (typeof window === 'undefined') return () => {};

  capturePartnerRefFromUrl();

  const onNavigate = () => capturePartnerRefFromUrl();
  window.addEventListener('popstate', onNavigate);
  return () => window.removeEventListener('popstate', onNavigate);
}
